import React from 'react';

interface TeamSectionProps {
    primaryColor: string;
    isEditing: boolean;
    sizeClasses: { heading: string; subheading: string; body: string; small: string };
}

export function TeamSection({ primaryColor, isEditing, sizeClasses }: TeamSectionProps) {
    const editClass = isEditing ? 'outline-dashed outline-2 outline-blue-400 outline-offset-2' : '';

    return (
        <section className="py-20 px-6 bg-white @container">
            <div className="max-w-6xl mx-auto">
                <h2 className="text-4xl font-bold text-center text-gray-900 mb-12">Meet Our Team</h2>
                <div className="grid @md:grid-cols-3 gap-8">
                    {[
                        { name: 'John Doe', role: 'CEO & Founder', initial: 'J' },
                        { name: 'Jane Smith', role: 'CTO', initial: 'J' },
                        { name: 'Mike Johnson', role: 'Head of Design', initial: 'M' }
                    ].map((member, idx) => (
                        <div key={idx} className="text-center">
                            <div
                                className="w-32 h-32 rounded-full mx-auto mb-4 flex items-center justify-center text-white text-4xl font-bold"
                                style={{ backgroundColor: primaryColor }}
                            >
                                {member.initial}
                            </div>
                            <h3
                                className={`${sizeClasses.subheading} font-bold text-gray-900 mb-2 ${editClass}`}
                                contentEditable={isEditing}
                                suppressContentEditableWarning
                            >
                                {member.name}
                            </h3>
                            <p
                                className={`${sizeClasses.body} text-gray-600 ${editClass}`}
                                contentEditable={isEditing}
                                suppressContentEditableWarning
                            >
                                {member.role}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
